import React, { useState } from 'react';

function RatingComponentWithoutNa({ label, name, value, onChange }) {
  const handleRadioChange = (event) => {
    const { value } = event.target;
    onChange && onChange(value); 
  };

  return (
    <div>
      <strong>{label}</strong>
      <div className="d-flex">
        {[1, 2, 3, 4, 5].map((ratingValue) => (
          <div className="form-check me-2" key={ratingValue}>
            <input
              className="form-check-input"
              type="radio"
              name={name}
              id={`flexRadioDefault${ratingValue}`}
              value={ratingValue}
              checked={value == String(ratingValue)}
              onChange={handleRadioChange}
            />
            <label className="form-check-label" htmlFor={`flexRadioDefault${ratingValue}`}>
              {ratingValue}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RatingComponentWithoutNa;
